import React, { Component } from "react";
import Header from "../home/Header";
import Footer from "../home/Footer";
import Linc from "../assets/img/blog/Linc-GivBee-donation-thermometer-2.png";
import Laughlin from "../assets/img/blog/Laughlin-5326.jpg";
import FoodOrderUI from "../assets/img/blog/FoodOrderUI-300x181.jpg";
import SerraCenter from "../assets/img/blog/logo2-300x137.jpg";
import FoodTrucks from "../assets/img/blog/texting-for-food-trucks-1-300x225.jpg";
import "./Blog.css";
class Blog extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <>
        <Header />

        <section id="blog" className="about">
          <div className="container">
            <div className="section-title" data-aos="fade-up">
              <h2>
                Looking for the latest texting trends and insights? You’ve come
                to the right place.
              </h2>
            </div>
            <div className="row content">
              <h4 style={{ margin: "1em 0em" }}>
                <b>Recent Posts</b>
              </h4>
              <div className="col-lg-8" data-aos="fade-up" data-aos-delay={150}>
                <div className="row">
                  <div className="col-lg-3">
                    <img
                      src={Linc}
                      className="img-fluid"
                      alt=""
                      data-aos="zoom-in"
                      data-aos-delay={500}
                    />
                  </div>
                  <div className="col-lg-9">
                    <p style={{ marginBottom: "0px" }}>
                      <a href="#">
                        Fundraising Event Donations Skyrocket with Digital and
                        Text Marketing Strategy
                      </a>
                    </p>
                    <p>
                      Each year, more than 600,000 individuals are released from
                      state and federal prisons, with more than 67% of them
                      being rearrested within three years. Having a positive
                      reentry experience is vital in breaking the cycle of
                      incarceration dependence and helping people readjust to
                      life outside of prison. Since June of 2000, LINC, Inc. has
                      been providing transitional living and case management
                      services […]
                    </p>
                  </div>
                </div>
                <div className="row" style={{ marginTop: "2em" }}>
                  <div className="col-lg-3">
                    <img
                      src={Laughlin}
                      style={{ width: "500px", height: "180px" }}
                      className="img-fluid"
                      alt=""
                      data-aos="zoom-in"
                      data-aos-delay={500}
                    />
                  </div>
                  <div className="col-lg-9">
                    <p style={{ marginBottom: "0px" }}>
                      <a href="#">
                        Customer Story: Korean Dumpling Business, Sarah’s Dumps
                      </a>
                    </p>
                    <p>
                      Almost every country in the world has some version of the
                      dumpling. In Italy, it’s the ravioli, in Poland, the
                      pierogi, in Japan, the gyoza and in Korea, it’s known as
                      mandu. In 2019, Sarah Williams-Scalise and her husband
                      Nate Williams-Scalise launched Sarah’s Dumps – a
                      Charleston, South Carolina-based Korean dumpling business.
                      Their mission? Share their love of dumplings, and to
                      celebrate child […]
                    </p>
                  </div>
                </div>
                <div className="row" style={{ marginTop: "2em" }}>
                  <div className="col-lg-3">
                    <img
                      src={FoodOrderUI}
                      style={{ width: "500px", height: "180px" }}
                      className="img-fluid"
                      alt=""
                      data-aos="zoom-in"
                      data-aos-delay={500}
                    />
                  </div>
                  <div className="col-lg-9">
                    <p style={{ marginBottom: "0px" }}>
                      <a href="#">
                        Text Messaging for Restaurants: “Your Carryout Order is
                        Ready!”
                      </a>
                    </p>
                    <p>
                      The whole world is hooked on texting. Collectively,
                      billions of texts are sent and received every day. We get
                      them from our friends, coworkers, schools, churches,
                      professional offices, local businesses and more. Studies
                      show that 98% of texts get read within the first three
                      minutes of being received. So why is text messaging for
                      restaurants something you should look into? Let’s find
                      out. What […]
                    </p>
                  </div>
                </div>
                <div className="row" style={{ marginTop: "2em" }}>
                  <div className="col-lg-3">
                    <img
                      src={SerraCenter}
                      style={{ width: "500px", height: "160px" }}
                      className="img-fluid"
                      alt=""
                      data-aos="zoom-in"
                      data-aos-delay={500}
                    />
                  </div>
                  <div className="col-lg-9">
                    <p style={{ marginBottom: "0px" }}>
                      <a href="#">
                        Texting Service Helps Non-profit Exceed Fundraising Goal
                        by 25%
                      </a>
                    </p>
                    <p>
                      For over 42 years, Serra Center has been providing
                      compassionate care for individuals with developmental
                      disabilities in the San Francisco Bay Area – offering
                      community-based residential care homes, independent and
                      supported living services. Like many non-profits,
                      government funding doesn’t cover all expenses, leaving the
                      organization reliant on donations and fundraising efforts
                      to keep […]
                    </p>
                  </div>
                </div>
                <div className="row" style={{ marginTop: "2em" }}>
                  <div className="col-lg-3">
                    <img
                      src={FoodTrucks}
                      style={{ width: "500px", height: "150px" }}
                      className="img-fluid"
                      alt=""
                      data-aos="zoom-in"
                      data-aos-delay={500}
                    />
                  </div>
                  <div className="col-lg-9">
                    <p style={{ marginBottom: "0px" }}>
                      <a href="#">
                        6 Reasons Why Texting for Food Trucks is a Great Idea
                      </a>
                    </p>
                    <p>
                      Just like any brick-and-mortar restaurant, there are
                      numerous responsibilities food truck owners manage every
                      day. Food cost, operating expenses, local regulations, and
                      of course, cooking…the list goes on and on. As a food
                      truck owner, one tool you can use to simplify your food
                      service, drive sales and increase customer satisfaction is
                      texting. Using technology to your advantage is one easy
                      […]
                    </p>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-4 pt-4 pt-lg-0"
                data-aos="fade-up"
                data-aos-delay={300}
                style={{ padding: "0em 5em" }}
              >
                <ul id="recentBlogList">
                  <li style={{ padding: "1em" }}>
                    {" "}
                    <form action="/" style={{ display: "flex" }}>
                      <input type="text" placeholder="Search.." name="search" />
                      <button type="submit">
                        <i
                          class="fa fa-search"
                          style={{ float: "right", position: "static" }}
                        ></i>
                      </button>
                    </form>
                  </li>
                </ul>
                <ul id="recentBlogList">
                  <li>
                    {" "}
                    <h5>Recent Posts</h5>
                  </li>
                  <li>
                    {" "}
                    <p>
                      <a href="">
                        Fundraising Event Donations Skyrocket with Digital and
                        Text Marketing Strategy
                      </a>
                    </p>
                  </li>
                  <li>
                    {" "}
                    <p>
                      <a href="">
                        Customer Story: Korean Dumpling Business, Sarah’s Dumps
                      </a>
                    </p>
                  </li>
                  <li>
                    {" "}
                    <p>
                      <a href="">
                        Text Messaging for Restaurants: “Your Carryout Order is
                        Ready!”
                      </a>
                    </p>
                  </li>
                  <li>
                    {" "}
                    <p>
                      <a href="">
                        Texting Service Helps Non-profit Exceed Fundraising Goal
                        by 25%
                      </a>
                    </p>
                  </li>
                  <li>
                    {" "}
                    <p>
                      <a href="">
                        6 Reasons Why Texting for Food Trucks is a Great Idea
                      </a>
                    </p>
                  </li>
                </ul>
                <ul id="recentBlogList" style={{ marginTop: "2em" }}>
                  <li>
                    {" "}
                    <h5>Archives</h5>
                  </li>
                  <li>
                    {" "}
                    <p>
                      <a href="">March 2020</a>
                    </p>
                  </li>
                  <li>
                    {" "}
                    <p>
                      <a href="">February 2020</a>
                    </p>
                  </li>
                  <li>
                    {" "}
                    <p>
                      <a href="">January 2020</a>
                    </p>
                  </li>
                </ul>
                <ul id="recentBlogList" style={{ marginTop: "2em" }}>
                  <li>
                    {" "}
                    <h5>Categories</h5>
                  </li>
                  <li>
                    {" "}
                    <p>
                      <a href="">Events</a>
                    </p>
                  </li>
                  <li>
                    {" "}
                    <p>
                      <a href="">Non-profits</a>
                    </p>
                  </li>
                  <li>
                    {" "}
                    <p>
                      <a href="">Restaurants and Food Trucks</a>
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </>
    );
  }
}

export default Blog;
